module.exports = "https://cdn.realtymogul.com/static/media/icon_references.96bf47f5.svg";